import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { IGameTypeSpectator } from "../../IGameTypeSpectator";
import { TournamentTypeRebuy } from "../TournamentTypeRebuy";

export class TournamentTypeRebuySpectator extends TournamentTypeRebuy implements IGameTypeSpectator {
    public get isGameTypeSpectator(): boolean {
        return true;
    }
}
classImplementsInterfaces(TournamentTypeRebuySpectator, "IGameTypeSpectator");
